import * as React from "react";
import { Spin } from 'antd';
import {
    LoadingOutlined,
} from '@ant-design/icons';
import './style/placementLoading.less';
import Logo from "../logo/Logo";


const antIcon = <LoadingOutlined style={{ fontSize: 24, color: '#666' }} />;

/**
 * Loading页
 */
export default class PlacementLoading extends React.Component<any, any> {
    render() {
        return (
            <div className="loading-wrapper">
                <div className="logo">
                    <Logo />
                </div>
                <Spin size="large" indicator={antIcon} tip="Loading..." />
            </div>
        )
    }
}
